<template>
    <div class="new-folder-form">
        <h3>Create new folder</h3>
        <input class="input" :class="errorMessage ? 'is-danger' : '' " type="text" v-model="folderName" placeholder="folder name">   
        <div class="warning" v-if="errorMessage">{{errorMessage}}</div>
        <div class="block">
            <button class="button is-success"                                 
                id="createNewFolder" v-on:click="createNewFolderClick">Create</button>
        </div>
        
    </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    name: "Folders",
    data() {
        return {
            folderName: "",
            errorMessage: null,
            existingFolders: [
                { text: 'One', value: 'A' },
                { text: 'Two', value: 'B' },
                { text: 'Three', value: 'C' }
            ]
        }
    },
    methods: {     
        ...mapActions(['createFolderAction']), 
        async createNewFolderClick(){
            this.$data.errorMessage = null;
            try{
                await this.createFolderAction(this.folderName);
                this.$router.push('tester');
            }
            catch(ex){
                console.log(ex);
                this.$data.errorMessage = "Can't create folder. Try to rename.";
            }
        } 
    },
}
</script>